import { Routes, Route } from "react-router-dom";
import PublicRoute from "./PublicRoute";
import PrivateRoute from "./PrivateRoute";
import { Login } from "../screen/login/Login";
import AIChatScreen from "../screen/aiChatScreen/AIChatScreen";
import { Welcome } from "../screen/welcome/Welcome";

const RootRouter = () => {
  return (
    <Routes>
      <Route
        path="/otp-login"
        element={
          <PublicRoute>
            <Login />
          </PublicRoute>
        }
      />
      <Route
        path="/"
        element={
          <PrivateRoute>
            <Welcome />
          </PrivateRoute>
        }
      />
      <Route
        path="/chat"
        element={
          <PrivateRoute>
            <AIChatScreen />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};

export default RootRouter;
